import cx from 'classnames';
import type { HTMLAttributes, PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';

const InfoCardsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 14px 0px 30px;
  color: #2e384d;
  flex-wrap: wrap;
  column-gap: 41px;
  row-gap: 14px;
`;

export const InfoCardsSection = ({
  className,
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>): ReactElement => (
  <InfoCardsContainer className={cx('textsSection', className)} {...rest}>
    {children}
  </InfoCardsContainer>
);
